import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { useExtensionContext } from "../modules/extension/ExtensionContext";
import { apiErrorText } from "app/popleads/networking/apiErrorText";
import { DEAL_CANCELLED } from "../modules/extension/utils/constants";
const useOlanakDurumDegistir = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { setSelectedDeal, selectedDeal, refetchDeals } = useExtensionContext();

    const olanakDurumDegistir = async ({
        id,
        profil,
        durum,
        lastStatus,
        kapanmaTarihi,
        nationalIdNumber,
        cancellationReason,
        cancellationNote,
    }) => {
        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "olanakDurumDegistir",
                id,
                profil,
                durum,
                lastStatus,
                kapanmaTarihi,
                nationalIdNumber: nationalIdNumber || "",
                cancellationReason,
                cancellationNote,
            });

            if (response.status === 200) {
                //toast.success("Status has been changed!");
                const deal = { ...selectedDeal };
                deal.durum = durum;
                deal.lastStatus = durum; // Yeni durum artık bir sonraki değişiklik için lastStatus olacak
                // Cancellation data belongs to a cancelled deal only - the backend clears it on any
                // other status, refetchDeals() then brings the stamped cancellation date.
                deal.cancellationReason = durum === DEAL_CANCELLED ? cancellationReason : null;
                deal.cancellationNote = durum === DEAL_CANCELLED ? cancellationNote : null;
                if (durum !== DEAL_CANCELLED) deal.cancellationDate = null;
                setSelectedDeal(deal);
                //refetchProfile();
                refetchDeals();
            } else {
                toast.error(apiErrorText(response));
            }
            return response;
        } catch (err) {
            toast.error(apiErrorText(err));
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, olanakDurumDegistir };
};

export default useOlanakDurumDegistir;
